// this is necessary so query invalidation works with the key, even if no filters are given
export function withOptionalFilters<K extends unknown[], F>(
  baseKey: K,
  filters?: F,
) {
  if (filters) {
    return [...baseKey, filters] as const;
  }
  return baseKey;
}
